<template>
  <div
    class="flex flex-row items-center gap-2 px-3"
    :class="{ '@container/link': hasFixedWidth }"
  >
    <router-link class="flex-1" :to="generateRoute()">
      <button
        type="button"
        class="inline-flex items-center rounded border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-none dark:border-white dark:bg-slate-700 dark:text-white"
        :title="label"
      >
        <FontAwesomeIcon
          :icon="['fal', icon]"
          size="sm"
          class="flex-shrink-0 cursor-pointer"
        />
        <span
          class="ml-2 truncate whitespace-nowrap"
          :class="{
            'hidden @8xs/link:inline-block': hasFixedWidth,
            'inline-block': !hasFixedWidth
          }"
        >
          {{ label }}
        </span>
        <!--
          Shown exactly where the label is not: a destination that counts
          something (today only the condolences) keeps its number beside the
          icon once the column is too narrow for the words. Without it, a
          narrowed column shows a feather that says nothing about whether there
          is anything to read behind it.
        -->
        <span
          v-if="hasCount"
          class="ml-1.5 font-semibold tabular-nums @8xs/link:hidden"
        >
          {{ count }}
        </span>
      </button>
    </router-link>
  </div>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { isFixedWidthColumn } from '@c/Dashboard/Content/Dossier/components/Body/columnWidth'

const DEFAULT_ICON = 'external-link'

export default {
  name: 'DashboardLink',
  components: { FontAwesomeIcon },
  props: {
    column: {
      type: Object,
      required: true
    },
    dossier: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasFixedWidth() {
      return isFixedWidthColumn(this.column)
    },
    field() {
      return this.dossier[this.column.field] ?? {}
    },
    label() {
      return this.field.label
    },
    icon() {
      return this.field.icon || DEFAULT_ICON
    },
    count() {
      return this.field.count
    },
    // Only the destinations the API sends a count for, and only where the label
    // can actually disappear: in an auto width column the words never go away,
    // so the number next to them would just be the same figure twice.
    hasCount() {
      return this.hasFixedWidth && Number.isFinite(this.count)
    }
  },
  methods: {
    generateRoute() {
      if (this.field.route_name === 'dossier_invoicing_route') {
        return '/dossier/' + this.field.id + '/invoicing'
      } else {
        return {
          name: this.field.route_name,
          params: { id: this.field.id }
        }
      }
    }
  }
}
</script>
